import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import {
    CssBaseline, CircularProgress, Container, Button, Grid, Divider, TextField, Tabs, Tab,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip,
    Dialog, DialogContent, DialogActions, DialogTitle, Chip
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import Footer from '../../components/footer';
import { injectIntl } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CancelIcon from '@material-ui/icons/Cancel';
import BlockIcon from '@material-ui/icons/Block';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import UndoIcon from '@material-ui/icons/Undo';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import { ContractStatusBadge, ProvisioningStatusBadge } from '../../components/status-badge';
import ConfirmActionDialog from '../../components/confirm-action-dialog';
import DangerConfirmDialog from '../../components/danger-confirm-dialog';
import DeprovisioningBanner from '../../components/deprovisioning-banner';
import ForceDropConfirmDialog from '../../components/force-drop-confirm-dialog';
import StatusHistoryTable from '../../components/status-history-table';
import HirerCredentialsCard from '../../components/hirer-credentials-card';
import ProvisioningErrorBanner from '../../components/provisioning-error-banner';
import ProvisioningDetailPanel from '../../components/provisioning-detail-panel';
import SectionCard from '../../components/section-card';
import AddProductWizard from '../../components/add-product-wizard';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminBillingService from '../../services/admin-billing.service';
import * as adminProductService from '../../services/admin-product.service';
import Api from "../../services/api";

class AdminTrialDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            detail: null,
            tabValue: 0,
            convertDialogOpen: false,
            cancelDialogOpen: false,
            blockDialogOpen: false,
            reactivateDialogOpen: false,
            dangerDialogOpen: false,
            dangerLoading: false,
            dangerSendingCode: false,
            dangerCodeSentState: null,
            deprovisioningStatus: null,
            aborting: false,
            forceDropDialogOpen: false,
            forceDropSending: false,
            forceDropSubmitting: false,
            forceDropCodeSentState: null,
            statusHistory: [],
            statusHistoryLoading: false,
            abortConfirmOpen: false,
            abortDropConfirmOpen: false,
            editTrialEndDate: '',
            saving: false,
            companySizes: [],
            companySizeDialogOpen: false,
            companySizeDialogValue: '',
            companySizeSaving: false,
            contractProducts: [],
            removeProductId: null,
            removeProductDialogOpen: false,
            addProductDialogOpen: false,
            productDetailDialog: { open: false, product: null },
            hirerConfig: null,
            confirmDialog: { open: false, title: '', message: '', action: null },
            actionLoading: false,
            urlSnapshots: [],
            urlSnapshotsLoading: false,
            // Assinar Plano stepper
            convertStep: 0,
            convertProducts: [],
            convertProductsLoading: false,
            convertSelectedProductIds: [],
            // Mapa por produto: { [appId]: { planId, planName, isShared, ppId, ppName, value } }
            convertProductSelections: {},
            // Planos disponíveis por produto: { [appId]: [...] }
            convertAvailablePlans: {},
            convertPlansLoading: false,
            // Periodicidades disponíveis por produto: { [appId]: [...] }
            convertAvailablePeriodicities: {},
            convertPeriodicitiesLoading: false,
        };
        this.closeNotification = this.closeNotification.bind(this);
    }

    componentDidMount() {
        const { currentTrial } = this.props;
        if (!currentTrial || !currentTrial.hirerid) {
            this.props.history.push(`/${this.props.match.params.lang}/admin-trials`);
            return;
        }
        this.loadAll(currentTrial.hirerid);
        this.loadCompanySizes();
    }

    loadCompanySizes = () => {
        adminBillingService.getCompanySizes()
            .then(r => {
                const sizes = r.data.success ? (r.data.data || []) : [];
                this.setState({ companySizes: sizes });
            })
            .catch(() => {});
    }

    openCompanySizeDialog = () => {
        this.setState({
            companySizeDialogOpen: true,
            companySizeDialogValue: this.state.detail?.companysizeid ? String(this.state.detail.companysizeid) : '',
        });
    }

    closeCompanySizeDialog = () => {
        this.setState({ companySizeDialogOpen: false });
    }

    handleSaveCompanySize = () => {
        const { detail, companySizeDialogValue } = this.state;
        const intl = this.props.intl;
        if (!detail?.hirerid) return;
        const companySizeId = companySizeDialogValue ? parseInt(companySizeDialogValue) : null;
        this.setState({ companySizeSaving: true });
        adminBillingService.updateHirerCompanySize(detail.hirerid, companySizeId)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        companySizeSaving: false,
                        companySizeDialogOpen: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({ id: "admin.hirer.company_size.update.success" })
                    });
                    this.loadDetail(detail.hirerid);
                } else {
                    this.setState({
                        companySizeSaving: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data.errors?.[0] || intl.formatMessage({ id: "admin.hirer.company_size.update.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    companySizeSaving: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: err.response?.data?.errors?.[0] || intl.formatMessage({ id: "admin.hirer.company_size.update.error" })
                });
                Api.kickoff(err);
            });
    }

    loadAll(hirerId) {
        this.loadDetail(hirerId);
        this.loadContractProducts(hirerId);
        this.loadHirerConfig(hirerId);
        this.loadUrlSnapshots(hirerId);
    }

    // Handlers de refresh por aba (cada aba chama apenas os endpoints pertinentes).
    refreshInfoTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadDetail(detail.hirerid);
    }
    refreshProductsTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadContractProducts(detail.hirerid);
    }
    refreshHirerConfigTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadDetail(detail.hirerid);
        this.loadHirerConfig(detail.hirerid, detail.workspace);
        this.loadUrlSnapshots(detail.hirerid);
    }
    refreshStatusHistoryTab = () => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.loadStatusHistory(detail.hirerid);
    }

    renderRefreshAction = (handler, disabled) => (
        <Tooltip title="Atualizar">
            <span>
                <IconButton size="small" onClick={handler} disabled={disabled}>
                    <RefreshIcon />
                </IconButton>
            </span>
        </Tooltip>
    );

    loadDetail(hirerId) {
        this.setState({ loading: true });
        adminBillingService.getTrialDetail(hirerId)
            .then(result => {
                if (result.data.success) {
                    const detail = result.data.data;
                    this.setState({ loading: false, detail, editTrialEndDate: detail.trialenddate ? detail.trialenddate.substring(0, 10) : '' });
                    // deprovisioningStatus depende de contractId — chamar só depois do detail carregado.
                    const contractId = detail?.contractid;
                    if (contractId) {
                        this.loadDeprovisioningStatus(hirerId, contractId);
                    } else {
                        console.warn('[admin-trial-detail] contractid ausente no detail — skipping loadDeprovisioningStatus');
                        this.setState({ deprovisioningStatus: null });
                    }
                } else { this.showError(result.data.errors ? result.data.errors[0] : null); }
            })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    loadDeprovisioningStatus(hirerId, contractId) {
        if (!contractId) {
            console.warn('[admin-trial-detail] loadDeprovisioningStatus chamado sem contractId');
            this.setState({ deprovisioningStatus: null });
            return;
        }
        adminBillingService.getDeprovisioningStatus(hirerId, contractId)
            .then(result => {
                this.setState({ deprovisioningStatus: result.data.success ? result.data.data : null });
            })
            .catch(() => this.setState({ deprovisioningStatus: null }));
    }

    loadStatusHistory = (hirerId) => {
        this.setState({ statusHistoryLoading: true });
        adminBillingService.getContractStatusHistory(hirerId, 100, 0)
            .then(result => {
                this.setState({
                    statusHistoryLoading: false,
                    statusHistory: result.data.success ? (result.data.data || []) : [],
                });
            })
            .catch(() => this.setState({ statusHistoryLoading: false, statusHistory: [] }));
    }

    // Abre confirm dialog antes de executar abort.
    handleAbortDeprovisioning = () => this.setState({ abortConfirmOpen: true });
    handleAbortDatabaseDrop = () => this.setState({ abortDropConfirmOpen: true });

    confirmAbortDeprovisioning = () => {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) return;
        this.setState({ aborting: true, abortConfirmOpen: false });
        adminBillingService.abortTrialDeprovisioning(detail.hirerid, detail.contractid)
            .then(result => {
                this.setState({ aborting: false });
                if (result.data.success) {
                    this.showSuccess('Desprovisionamento abortado com sucesso.');
                    // Refresh completo: status do contrato volta ao anterior + banner some.
                    this.loadDetail(detail.hirerid);
                } else {
                    this.showError(result.data.errors?.[0]);
                }
            })
            .catch(err => { this.setState({ aborting: false }); this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    confirmAbortDatabaseDrop = () => {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) return;
        this.setState({ aborting: true, abortDropConfirmOpen: false });
        adminBillingService.abortDatabaseDrop(detail.hirerid, detail.contractid)
            .then(result => {
                this.setState({ aborting: false });
                if (result.data.success) {
                    this.showSuccess('Deleção do banco de dados abortada com sucesso.');
                    this.loadDetail(detail.hirerid);
                } else {
                    this.showError(result.data.errors?.[0]);
                }
            })
            .catch(err => { this.setState({ aborting: false }); this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    openForceDropDialog = () => { this.setState({ forceDropDialogOpen: true, forceDropCodeSentState: null, forceDropError: null }); }
    closeForceDropDialog = () => { this.setState({ forceDropDialogOpen: false, forceDropCodeSentState: null }); }

    handleSendForceDropCode = ({ email }) => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.setState({ forceDropSending: true });
        adminBillingService.sendForceDropTwoFactorCode(detail.hirerid, email)
            .then(result => {
                this.setState({ forceDropSending: false });
                if (result.data.success) {
                    this.setState({ forceDropCodeSentState: result.data.data });
                } else {
                    this.setState({ forceDropCodeSentState: { sent: false, errormessage: result.data.errors?.[0] || 'Falha ao enviar código' } });
                }
            })
            .catch(err => { this.setState({ forceDropSending: false, forceDropCodeSentState: { sent: false, errormessage: err.response?.data?.errors?.[0] || 'Erro inesperado' } }); Api.kickoff(err); });
    }

    handleForceDatabaseDrop = (payload) => {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) return;
        this.setState({ forceDropSubmitting: true, forceDropError: null });
        adminBillingService.forceDatabaseDrop(detail.hirerid, detail.contractid, payload)
            .then(result => {
                if (result.data.success) {
                    this.setState({ forceDropSubmitting: false, forceDropDialogOpen: false, forceDropCodeSentState: null, forceDropError: null });
                    this.showSuccess('Drop imediato executado. Aguardando confirmação no background.');
                    setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-trials`), 1500);
                } else {
                    const msg = result.data.errors?.[0] || 'Falha ao forçar drop';
                    this.setState({ forceDropSubmitting: false, forceDropError: msg });
                }
            })
            .catch(err => {
                const msg = err.response?.data?.errors?.[0] || 'Falha ao forçar drop';
                this.setState({ forceDropSubmitting: false, forceDropError: msg });
                Api.kickoff(err);
            });
    }

    loadContractProducts(hirerId) {
        adminBillingService.getContractProducts(hirerId)
            .then(result => { this.setState({ contractProducts: result.data.success ? (result.data.data || []) : [] }); })
            .catch(() => this.setState({ contractProducts: [] }));
    }

    loadHirerConfig(hirerId, workspace = null) {
        // workspace opcional: tb_hirer_config pode ter multiplas linhas por hirer
        // (DNS/subdomains distintos). Caller passa explicito quando tem; senao tenta
        // ler de this.state.detail.workspace. Quando ambos nulos (initial load antes
        // do detail carregar), cai em LIMIT 1 (comportamento legado).
        const ws = workspace || this.state.detail?.workspace || null;
        adminBillingService.getTrialHirerConfig(hirerId, ws)
            .then(result => { this.setState({ hirerConfig: result.data.success ? result.data.data : null }); })
            .catch(() => this.setState({ hirerConfig: null }));
    }

    loadUrlSnapshots(hirerId) {
        this.setState({ urlSnapshotsLoading: true });
        adminBillingService.getUrlSnapshots(hirerId)
            .then(result => { this.setState({ urlSnapshots: result.data.success ? (result.data.data || []) : [], urlSnapshotsLoading: false }); })
            .catch(() => this.setState({ urlSnapshots: [], urlSnapshotsLoading: false }));
    }

    handleRestoreSnapshot = (snapshot) => {
        const intl = this.props.intl;
        this.openConfirm(
            'Restaurar URLs do Snapshot',
            `Deseja restaurar as URLs de API do snapshot "${snapshot.snapshottype}" (criado em ${new Date(snapshot.createdat).toLocaleString('pt-BR')})? As URLs atuais do hirer_config serão sobrescritas.`,
            () => {
                this.setState({ actionLoading: true, confirmDialog: { open: false } });
                adminBillingService.restoreUrlSnapshot(this.state.detail.hirerid, snapshot.id)
                    .then(result => {
                        if (result.data.success) {
                            this.showSuccess('URLs restauradas com sucesso');
                            this.loadHirerConfig(this.state.detail.hirerid, this.state.detail.workspace);
                        } else { this.showError(result.data.errors?.[0]); }
                    })
                    .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
            }
        );
    }

    showError(message) {
        const intl = this.props.intl;
        this.setState({ loading: false, saving: false, actionLoading: false, openNotification: true, notificationVariant: 'error', notificationMessage: message || intl.formatMessage({ id: "process.error" }) });
    }
    showSuccess(message) {
        this.setState({ loading: false, saving: false, actionLoading: false, openNotification: true, notificationVariant: 'success', notificationMessage: message });
    }

    handleSaveTrialEndDate = () => {
        const { detail, editTrialEndDate } = this.state;
        const intl = this.props.intl;
        if (!editTrialEndDate) { this.setState({ openNotification: true, notificationVariant: 'error', notificationMessage: intl.formatMessage({ id: "admin.trial.end.date.required" }) }); return; }
        this.setState({ saving: true });
        adminBillingService.updateTrial(detail.hirerid, { trialEndDate: editTrialEndDate })
            .then(result => { if (result.data.success) { this.showSuccess(intl.formatMessage({ id: "edit.success" })); this.loadDetail(detail.hirerid); } else { this.showError(result.data.errors?.[0]); } })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }
    handleConvert = () => {
        const currentProductIds = (this.state.contractProducts || []).map(p => p.applicationid ?? p.applicationId);
        this.setState({
            convertDialogOpen: true, convertStep: 0,
            convertSelectedProductIds: currentProductIds,
            convertProductSelections: {},
            convertAvailablePlans: {}, convertAvailablePeriodicities: {},
            convertProducts: [], convertProductsLoading: true,
        });
        adminProductService.getProducts(true)
            .then(r => this.setState({ convertProducts: r.data.success ? (r.data.data || []) : [], convertProductsLoading: false }))
            .catch(() => this.setState({ convertProductsLoading: false }));
    }
    handleConvertToggleProduct = (id) => {
        this.setState(prev => {
            const s = [...prev.convertSelectedProductIds];
            const i = s.indexOf(id);
            if (i > -1) {
                s.splice(i, 1);
                const sel = { ...prev.convertProductSelections };
                delete sel[id];
                return { convertSelectedProductIds: s, convertProductSelections: sel };
            }
            s.push(id);
            return { convertSelectedProductIds: s };
        });
    }
    handleConvertLoadPlansPerProduct = () => {
        this.setState({ convertPlansLoading: true });
        adminBillingService.getActivePlans(false)
            .then(r => {
                if (r.data.success) {
                    const allPPs = r.data.data || [];
                    const plansByApp = {};
                    this.state.convertSelectedProductIds.forEach(appId => {
                        const planMap = {};
                        allPPs.filter(pp => (pp.applicationid ?? pp.applicationId) === appId && (pp.planid ?? pp.planId) !== 1)
                            .forEach(pp => {
                                const key = pp.planid ?? pp.planId;
                                if (!planMap[key]) planMap[key] = { id: key, name: pp.planname ?? pp.planName, isShared: pp.isshared ?? pp.isShared };
                            });
                        plansByApp[appId] = Object.values(planMap);
                    });
                    this.setState({ convertAvailablePlans: plansByApp, convertPlansLoading: false });
                } else { this.setState({ convertPlansLoading: false }); }
            })
            .catch(() => this.setState({ convertPlansLoading: false }));
    }
    handleConvertSelectPlanForApp = (appId, plan) => {
        this.setState(prev => {
            const sel = { ...prev.convertProductSelections };
            sel[appId] = { planId: plan.id, planName: plan.name, isShared: plan.isShared, ppId: null, ppName: null, value: null };
            return { convertProductSelections: sel };
        });
    }
    handleConvertLoadPeriodicitiesPerProduct = () => {
        this.setState({ convertPeriodicitiesLoading: true });
        adminBillingService.getActivePlans(false)
            .then(r => {
                if (r.data.success) {
                    const allPPs = r.data.data || [];
                    const perByApp = {};
                    this.state.convertSelectedProductIds.forEach(appId => {
                        const sel = this.state.convertProductSelections[appId];
                        if (!sel) return;
                        perByApp[appId] = allPPs.filter(pp =>
                            (pp.applicationid ?? pp.applicationId) === appId &&
                            (pp.planid ?? pp.planId) === sel.planId
                        );
                    });
                    this.setState({ convertAvailablePeriodicities: perByApp, convertPeriodicitiesLoading: false });
                } else { this.setState({ convertPeriodicitiesLoading: false }); }
            })
            .catch(() => this.setState({ convertPeriodicitiesLoading: false }));
    }
    handleConvertSelectPeriodicityForApp = (appId, pp) => {
        this.setState(prev => {
            const sel = { ...prev.convertProductSelections };
            sel[appId] = {
                ...sel[appId],
                ppId: pp.id,
                ppName: pp.periodicityname ?? pp.periodicityName,
                value: pp.planvaluepermonth ?? pp.planValuePerMonth ?? pp.value ?? 0
            };
            return { convertProductSelections: sel };
        });
    }
    handleConvertNext = () => {
        const { convertStep } = this.state;
        if (convertStep === 0) this.handleConvertLoadPlansPerProduct();
        if (convertStep === 1) this.handleConvertLoadPeriodicitiesPerProduct();
        this.setState(prev => ({ convertStep: prev.convertStep + 1 }));
    }
    handleConvertConfirm = () => {
        const { detail, convertProductSelections } = this.state;
        const intl = this.props.intl;
        this.setState({ convertDialogOpen: false, loading: true });
        const products = Object.entries(convertProductSelections).map(([appId, sel]) => ({
            applicationId: parseInt(appId), planPeriodicityId: sel.ppId
        }));
        // Determinar se algum produto é dedicado
        const hasDedicated = Object.values(convertProductSelections).some(s => s.isShared === false);
        const serviceCall = hasDedicated
            ? adminBillingService.convertToDedicated(detail.hirerid, products)
            : adminBillingService.convertToShared(detail.hirerid, products);
        serviceCall
            .then(result => {
                if (result.data.success) {
                    this.showSuccess(intl.formatMessage({ id: "admin.trial.convert.success" }));
                    setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-subscriptions`), 1500);
                } else { this.showError(result.data.errors?.[0]); }
            })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); this.setState({ loading: false }); Api.kickoff(err); });
    }
    handleCancelConfirm = () => {
        const { detail } = this.state; const intl = this.props.intl;
        this.setState({ cancelDialogOpen: false, loading: true });
        adminBillingService.cancelTrial(detail.hirerid)
            .then(result => { if (result.data.success) { this.showSuccess(intl.formatMessage({ id: "admin.trial.cancel.success" })); setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-trials`), 1500); } else { this.showError(result.data.errors?.[0]); } })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }
    handleBlockConfirm = () => {
        const { detail } = this.state; const intl = this.props.intl;
        this.setState({ blockDialogOpen: false, loading: true });
        adminBillingService.blockHirer(detail.hirerid, 'admin')
            .then(result => { if (result.data.success) { this.showSuccess(intl.formatMessage({ id: "admin.subscription.block.success" })); this.loadDetail(detail.hirerid); } else { this.showError(result.data.errors?.[0]); } })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }
    handleUnblock = () => {
        const { detail } = this.state; const intl = this.props.intl;
        this.setState({ loading: true });
        adminBillingService.unblockHirer(detail.hirerid)
            .then(result => { if (result.data.success) { this.showSuccess(intl.formatMessage({ id: "admin.subscription.unblock.success" })); this.loadDetail(detail.hirerid); } else { this.showError(result.data.errors?.[0]); } })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }
    handleReactivateConfirm = () => {
        const { detail } = this.state; const intl = this.props.intl;
        this.setState({ reactivateDialogOpen: false, loading: true });
        adminBillingService.reactivateTrial(detail.hirerid)
            .then(result => { if (result.data.success) { this.showSuccess(intl.formatMessage({ id: "admin.trial.reactivate.success" })); this.loadDetail(detail.hirerid); } else { this.showError(result.data.errors?.[0]); } })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }
    handleSendScheduleDeprovCode = ({ email }) => {
        const { detail } = this.state;
        if (!detail?.hirerid) return;
        this.setState({ dangerSendingCode: true });
        adminBillingService.sendScheduleDeprovTwoFactorCode(detail.hirerid, email)
            .then(result => {
                if (result.data.success) {
                    this.setState({ dangerSendingCode: false, dangerCodeSentState: { ...result.data.data, sent: true } });
                } else {
                    this.setState({ dangerSendingCode: false, dangerCodeSentState: { sent: false, errormessage: result.data.errors?.[0] || 'Falha ao enviar código' } });
                }
            })
            .catch(err => { this.setState({ dangerSendingCode: false, dangerCodeSentState: { sent: false, errormessage: 'Falha ao enviar código' } }); Api.kickoff(err); });
    }

    handleScheduleDeprovisioning = ({ reason, confirmWorkspace, twoFactorCode }) => {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) return;
        this.setState({ dangerLoading: true });
        adminBillingService.scheduleTrialDeprovisioning(detail.hirerid, detail.contractid, { reason, confirmWorkspace, twoFactorCode })
            .then(result => {
                if (result.data.success) {
                    this.setState({ dangerLoading: false, dangerDialogOpen: false, dangerCodeSentState: null });
                    this.showSuccess('Desprovisionamento agendado. O ambiente será removido após o período de carência.');
                    setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-trials`), 1500);
                } else {
                    this.setState({ dangerLoading: false });
                    this.showError(result.data.errors?.[0]);
                }
            })
            .catch(err => { this.setState({ dangerLoading: false }); this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }
    handleAddProductConfirm = (productData) => {
        const { detail } = this.state; const intl = this.props.intl;
        this.setState({ addProductDialogOpen: false, loading: true });
        adminBillingService.addProductToContract(detail.hirerid, productData)
            .then(result => { if (result.data.success) { this.showSuccess(intl.formatMessage({ id: "admin.contract.products.remove.success" })); this.loadContractProducts(detail.hirerid); } else { this.showError(result.data.errors?.[0]); } })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }
    handleRemoveProductConfirm = () => {
        const { detail, removeProductId } = this.state; const intl = this.props.intl;
        this.setState({ removeProductDialogOpen: false, loading: true });
        adminBillingService.removeProductFromContract(detail.hirerid, removeProductId)
            .then(result => { if (result.data.success) { this.showSuccess(intl.formatMessage({ id: "admin.contract.products.remove.success" })); this.loadContractProducts(detail.hirerid); } else { this.showError(result.data.errors?.[0]); } })
            .catch(err => { this.showError(err.response?.data?.errors?.[0]); Api.kickoff(err); });
    }

    openConfirm = (title, message, action) => this.setState({ confirmDialog: { open: true, title, message, action } });

    closeNotification() { this.setState({ openNotification: false }); }

    renderUrlField(label, value) {
        if (!value) return (
            <Grid item xs={12} sm={6}><Typography variant="body2" color="textSecondary">{label}</Typography><Typography variant="body1">-</Typography></Grid>
        );
        const url = value.startsWith('http') ? value : `https://${value}`;
        return (
            <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="textSecondary">{label}</Typography>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Typography variant="body1" style={{ wordBreak: 'break-all' }}>{value}</Typography>
                    <Tooltip title="Abrir em nova aba">
                        <IconButton size="small" onClick={() => window.open(url, '_blank')}><OpenInNewIcon style={{ fontSize: 16, color: '#1976d2' }} /></IconButton>
                    </Tooltip>
                </div>
            </Grid>
        );
    }

    renderInfoTab() {
        const { detail } = this.state;
        const intl = this.props.intl;
        if (!detail) return null;
        // Quando deprovisionamento está agendado ou em execução, todas as outras ações
        // são desabilitadas. Único caminho: abortar (banner) ou forçar deleção imediata.
        const ds = this.state.deprovisioningStatus;
        const isDeprovisioningInProgress = ds?.provisioningstatus === 'deprovisioning_scheduled'
                                            || ds?.provisioningstatus === 'deprovisioning';
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <SectionCard
                        context="info"
                        title={intl.formatMessage({ id: "admin.trial.detail" })}
                        actions={this.renderRefreshAction(this.refreshInfoTab, this.state.loading)}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.trial.company.name" })}</Typography><Typography variant="body1" style={{ fontWeight: 500 }}>{detail.name || '—'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Workspace</Typography><Typography variant="body1" style={{ fontFamily: 'monospace', fontWeight: 500 }}>{detail.workspace || '—'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "email" })}</Typography><Typography variant="body1">{detail.email || '—'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.subscription.plan" })}</Typography><Typography variant="body1">{detail.planname || '—'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Status do contrato</Typography><ContractStatusBadge statusId={detail.contractstatusid} /></Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" color="textSecondary">Status de provisionamento</Typography>
                                {detail.provisioningstatus
                                    ? <ProvisioningStatusBadge status={detail.provisioningstatus} />
                                    : <Typography variant="body1" style={{ color: '#9e9e9e' }}>—</Typography>}
                            </Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.trial.days.remaining" })}</Typography><Typography variant="body1">{detail.daysremaining != null ? (detail.daysremaining > 0 ? `${detail.daysremaining} dias` : 'Expirado') : '—'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Hirer ID</Typography><Typography variant="body1" style={{ fontFamily: 'monospace' }}>{detail.hirerid}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Contract ID</Typography><Typography variant="body1" style={{ fontFamily: 'monospace' }}>{detail.contractid || '—'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Gateway Customer ID</Typography><Typography variant="body1" style={{ fontFamily: 'monospace', fontSize: 12 }}>{detail.gatewaycustomerid || '—'}</Typography></Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.hirer.company_size" })}</Typography>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <Typography variant="body1">{detail.companysizename || '—'}</Typography>
                                    <IconButton size="small" onClick={this.openCompanySizeDialog} title="Editar"><EditIcon fontSize="small" /></IconButton>
                                </div>
                            </Grid>
                        </Grid>

                        {/* Banner de erro quando provisionamento/desprovisionamento falhou */}
                        <div style={{ marginTop: 12 }}>
                            <ProvisioningErrorBanner
                                status={ds?.provisioningstatus}
                                errorMessage={ds?.errormessage}
                                failedStep={ds?.failedstep}
                            />
                        </div>
                    </SectionCard>
                </Grid>

                {/* Editable Fields */}
                <Grid item xs={12}>
                    <SectionCard context="edit" title={intl.formatMessage({ id: "admin.trial.edit.fields" })}>
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12} sm={4}><TextField label={intl.formatMessage({ id: "admin.trial.end.date" })} type="date" value={this.state.editTrialEndDate} onChange={(e) => this.setState({ editTrialEndDate: e.target.value })} InputLabelProps={{ shrink: true }} fullWidth variant="outlined" size="small" disabled={isDeprovisioningInProgress} /></Grid>
                            <Grid item xs={12} sm={2}><Button variant="contained" color="primary" onClick={this.handleSaveTrialEndDate} disabled={this.state.saving || isDeprovisioningInProgress} style={isDeprovisioningInProgress ? { backgroundColor: '#bdbdbd', color: '#fff', cursor: 'not-allowed', boxShadow: 'none', textTransform: 'none' } : { textTransform: 'none' }}>{intl.formatMessage({ id: "save" })}</Button></Grid>
                        </Grid>
                    </SectionCard>
                </Grid>

                {/* Actions */}
                <Grid item xs={12}>
                    <SectionCard context="settings" title={intl.formatMessage({ id: "admin.trial.actions" })}>
                    {(() => {
                        const status = detail.contractstatusid;
                        const cancelDisabled = status === 4 || isDeprovisioningInProgress;
                        const blockDisabled = status === 4 || status === 6 || isDeprovisioningInProgress;
                        const reactivateDisabled = status !== 4 || isDeprovisioningInProgress;
                        const convertDisabled = (status !== 5 && status !== 7) || isDeprovisioningInProgress;
                        const dangerStyle = (disabled) => ({
                            backgroundColor: disabled ? '#bdbdbd' : '#f44336',
                            color: '#fff',
                            marginRight: 8,
                            cursor: disabled ? 'not-allowed' : 'pointer',
                            boxShadow: disabled ? 'none' : undefined,
                        });
                        const blockStyle = (disabled) => ({
                            backgroundColor: disabled ? '#bdbdbd' : '#ff9800',
                            color: '#fff',
                            marginRight: 8,
                            cursor: disabled ? 'not-allowed' : 'pointer',
                            boxShadow: disabled ? 'none' : undefined,
                        });
                        const reactivateStyle = (disabled) => ({
                            backgroundColor: disabled ? '#bdbdbd' : '#4caf50',
                            color: '#fff',
                            cursor: disabled ? 'not-allowed' : 'pointer',
                            boxShadow: disabled ? 'none' : undefined,
                        });
                        return (
                            <>
                                <Button variant="contained" color="primary" onClick={this.handleConvert} style={{ marginRight: 8, ...(convertDisabled ? { backgroundColor: '#bdbdbd', color: '#fff', cursor: 'not-allowed', boxShadow: 'none' } : {}) }} disabled={convertDisabled}>{intl.formatMessage({ id: "admin.trial.convert" })}</Button>
                                <Button variant="contained" style={dangerStyle(cancelDisabled)} onClick={() => this.setState({ cancelDialogOpen: true })} disabled={cancelDisabled}>{intl.formatMessage({ id: "admin.trial.cancel" })}</Button>
                                {status !== 6 ? (
                                    <Button variant="contained" style={blockStyle(blockDisabled)} onClick={() => this.setState({ blockDialogOpen: true })} disabled={blockDisabled}>{intl.formatMessage({ id: "admin.subscription.block" })}</Button>
                                ) : (
                                    <Button variant="contained" style={isDeprovisioningInProgress ? { backgroundColor: '#bdbdbd', color: '#fff', marginRight: 8, cursor: 'not-allowed', boxShadow: 'none' } : { backgroundColor: '#4caf50', color: '#fff', marginRight: 8 }} onClick={this.handleUnblock} disabled={isDeprovisioningInProgress}>{intl.formatMessage({ id: "admin.subscription.unblock" })}</Button>
                                )}
                                <Button variant="contained" style={reactivateStyle(reactivateDisabled)} onClick={() => this.setState({ reactivateDialogOpen: true })} disabled={reactivateDisabled}>{intl.formatMessage({ id: "admin.trial.reactivate" })}</Button>
                            </>
                        );
                    })()}
                    </SectionCard>
                </Grid>

                {/* Zona de perigo */}
                <Grid item xs={12}>
                    <SectionCard context="danger" title="Zona de perigo">
                            <Typography variant="body2" style={{ color: '#757575', marginBottom: 16, lineHeight: 1.5 }}>
                                Desprovisionar remove definitivamente o ambiente do contratante (infra dedicada, assinatura no gateway, registros SaaS). O banco de dados do contratante é preservado por 30 dias para possibilitar restauração, depois é deletado permanentemente.
                            </Typography>
                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                {/* "Excluir trial" some quando já há desprovisionamento agendado/em execução —
                                    nesse estado, único caminho é abortar (banner) ou forçar (botão ao lado). */}
                                {!isDeprovisioningInProgress && (
                                    <Button
                                        variant="contained"
                                        startIcon={<DeleteForeverIcon />}
                                        onClick={() => this.setState({ dangerDialogOpen: true })}
                                        style={{
                                            backgroundColor: '#d32f2f',
                                            color: '#fff',
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            boxShadow: '0 2px 8px rgba(211,47,47,0.3)',
                                        }}
                                    >
                                        Excluir trial (desprovisionar)
                                    </Button>
                                )}
                                {/* Botão "Forçar drop" só aparece se já houver desprovisionamento solicitado/agendado.
                                    É um acelerador, não uma porta direta de destruição. */}
                                {(this.state.deprovisioningStatus?.provisioningstatus === 'deprovisioning_scheduled'
                                  || this.state.deprovisioningStatus?.dropstatus === 'pending') && (
                                    <Button
                                        variant="contained"
                                        onClick={this.openForceDropDialog}
                                        style={{
                                            backgroundColor: '#b71c1c',
                                            color: '#fff',
                                            textTransform: 'none',
                                            fontWeight: 700,
                                            boxShadow: '0 2px 12px rgba(183,28,28,0.4)',
                                            border: '2px solid #7f0000',
                                        }}
                                    >
                                        ⚠ Forçar deleção imediata (2FA)
                                    </Button>
                                )}
                            </div>
                    </SectionCard>
                </Grid>
            </Grid>
        );
    }

    renderProductsTab() {
        const intl = this.props.intl;
        const { contractProducts } = this.state;
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <SectionCard
                        context="tree"
                        title={intl.formatMessage({ id: "admin.contract.products.title" })}
                        actions={
                            <>
                                {this.renderRefreshAction(this.refreshProductsTab, false)}
                                <Button variant="contained" color="primary" size="small" onClick={() => this.setState({ addProductDialogOpen: true })} style={{ textTransform: 'none' }}>
                                    {intl.formatMessage({ id: "admin.subscription.add.product" })}
                                </Button>
                            </>
                        }
                    >
                        {contractProducts.length === 0 ? (
                            <Typography variant="body2" color="textSecondary" style={{ padding: '16px 0' }}>{intl.formatMessage({ id: "admin.contract.products.empty" })}</Typography>
                        ) : (
                            <TableContainer component={Paper} variant="outlined"><Table size="small">
                                <TableHead><TableRow style={{ backgroundColor: '#fafafa' }}>
                                    <TableCell>{intl.formatMessage({ id: "admin.contract.products.product" })}</TableCell>
                                    <TableCell>{intl.formatMessage({ id: "admin.contract.products.plan" })}</TableCell>
                                    <TableCell align="right">{intl.formatMessage({ id: "admin.contract.products.qty" })}</TableCell>
                                    <TableCell align="right">{intl.formatMessage({ id: "admin.contract.products.value" })}</TableCell>
                                    <TableCell align="center">{intl.formatMessage({ id: "actions" })}</TableCell>
                                </TableRow></TableHead>
                                <TableBody>
                                    {contractProducts.map((prod, idx) => (
                                        <TableRow key={idx} hover style={{ cursor: 'pointer' }} onClick={() => this.setState({ productDetailDialog: { open: true, product: prod } })}>
                                            <TableCell><strong>{prod.applicationname}</strong></TableCell>
                                            <TableCell>{prod.planname}{prod.periodicityname ? ` (${prod.periodicityname})` : ''}</TableCell>
                                            <TableCell align="right">{prod.quantity}</TableCell>
                                            <TableCell align="right">R$ {Number(prod.planvaluepermonth || 0).toFixed(2)}</TableCell>
                                            <TableCell align="center">
                                                <Tooltip title={intl.formatMessage({ id: "admin.contract.products.remove" })}>
                                                    <IconButton size="small" onClick={(e) => { e.stopPropagation(); this.setState({ removeProductDialogOpen: true, removeProductId: prod.applicationid }); }} style={{ color: '#e53935' }}>
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table></TableContainer>
                        )}
                    </SectionCard>
                </Grid>
            </Grid>
        );
    }

    renderProductDetailDialog() {
        const { productDetailDialog } = this.state;
        const intl = this.props.intl;
        const prod = productDetailDialog.product;
        if (!prod) return null;

        const fields = [
            { label: intl.formatMessage({ id: "admin.contract.products.product" }), value: prod.applicationname },
            { label: intl.formatMessage({ id: "admin.contract.products.plan" }), value: `${prod.planname || '-'}${prod.periodicityname ? ` (${prod.periodicityname})` : ''}` },
            { label: intl.formatMessage({ id: "admin.contract.products.qty" }), value: prod.quantity },
            { label: intl.formatMessage({ id: "admin.contract.products.value" }) + '/mes', value: `R$ ${Number(prod.planvaluepermonth || 0).toFixed(2)}` },
            { label: 'Valor Total', value: `R$ ${Number(prod.planvalue || 0).toFixed(2)}` },
            { label: intl.formatMessage({ id: "admin.subscription.agents" }), value: prod.agentlimitquantity ?? '-' },
            { label: intl.formatMessage({ id: "admin.subscription.disk" }), value: prod.disklimitusage != null ? `${prod.disklimitusage} MB` : '-' },
            { label: intl.formatMessage({ id: "admin.subscription.attendances" }), value: prod.attendancelimitpermonth ?? '-' },
            { label: 'Valor Agente Adicional', value: prod.additionalvalueagent != null ? `R$ ${Number(prod.additionalvalueagent).toFixed(2)}` : '-' },
            { label: 'Valor Atendimento', value: prod.attendancevalue != null ? `R$ ${Number(prod.attendancevalue).toFixed(4)}` : '-' },
            { label: 'Valor Disco Excedente', value: prod.diskoveragevalue != null ? `R$ ${Number(prod.diskoveragevalue).toFixed(4)}` : '-' },
            { label: intl.formatMessage({ id: "admin.pp.billing.mode" }), value: prod.billingmode || 'unit' },
            { label: intl.formatMessage({ id: "admin.pp.credit.monthly" }), value: prod.creditamountmonthly != null ? `R$ ${Number(prod.creditamountmonthly).toFixed(2)}` : '-' },
            { label: intl.formatMessage({ id: "admin.pp.credit.alert" }), value: prod.creditalertthreshold != null ? `R$ ${Number(prod.creditalertthreshold).toFixed(2)}` : '-' },
            { label: intl.formatMessage({ id: "admin.pp.credit.auto.recharge" }), value: prod.creditautorechchargeenabled ? 'Sim' : 'Nao' },
            { label: intl.formatMessage({ id: "admin.pp.credit.recharge.amount" }), value: prod.creditautorechargeamount != null ? `R$ ${Number(prod.creditautorechargeamount).toFixed(2)}` : '-' },
            { label: intl.formatMessage({ id: "admin.pp.credit.recharge.trigger" }), value: prod.creditautorechargetrigger != null ? `R$ ${Number(prod.creditautorechargetrigger).toFixed(2)}` : '-' },
        ];

        return (
            <Dialog open={productDetailDialog.open} onClose={() => this.setState({ productDetailDialog: { open: false, product: null } })} maxWidth="sm" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                    <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>{prod.applicationname} - Detalhes do Produto</Typography>
                    <IconButton size="small" onClick={() => this.setState({ productDetailDialog: { open: false, product: null } })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                </div>
                <Divider />
                <DialogContent style={{ padding: '16px 24px' }}>
                    <div style={{ overflowY: 'auto', maxHeight: '70vh', paddingRight: 8 }}>
                        <Grid container spacing={2}>
                            {fields.map((f, i) => (
                                <Grid item xs={6} key={i}>
                                    <Typography variant="body2" color="textSecondary">{f.label}</Typography>
                                    <Typography variant="body1">{f.value}</Typography>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                </DialogContent>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                    <Button onClick={() => this.setState({ productDetailDialog: { open: false, product: null } })} style={{ textTransform: 'none', fontWeight: 500 }}>{intl.formatMessage({ id: "close" })}</Button>
                </div>
            </Dialog>
        );
    }

    renderProvisioningTab() {
        const { detail } = this.state;
        if (!detail?.hirerid || !detail?.contractid) {
            return (
                <SectionCard context="provisioning">
                    <Typography variant="body2" color="textSecondary" style={{ padding: 16, textAlign: 'center' }}>
                        Aguardando dados do contrato...
                    </Typography>
                </SectionCard>
            );
        }
        return (
            <ProvisioningDetailPanel
                hirerId={detail.hirerid}
                contractId={detail.contractid}
                defaultEmail={this.props.userSession?.user?.email || ''}
                enablePolling={true}
                onLoadingChange={(loading) => this.setState({ loading })}
                onForceDropSuccess={() => setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-trials`), 1500)}
                onNotify={(variant, msg) => this.setState({ openNotification: true, notificationVariant: variant, notificationMessage: msg })}
            />
        );
    }

    renderHirerConfigTab() {
        const { hirerConfig, detail } = this.state;

        return (
            <Grid container spacing={3}>
                {/* Primeiro bloco: Dados do contrato (hirer + responsável + access key) */}
                <Grid item xs={12}>
                    <HirerCredentialsCard
                        detail={detail}
                        onCopied={(msg) => this.showSuccess(msg)}
                        actions={this.renderRefreshAction(this.refreshHirerConfigTab, false)}
                    />
                </Grid>

                {!hirerConfig && (
                    <Grid item xs={12}>
                        <SectionCard context="info" title="Configuração do contratante">
                            <Typography variant="body2" color="textSecondary" style={{ padding: 16, textAlign: 'center' }}>
                                Nenhuma configuração encontrada para este contratante.
                            </Typography>
                        </SectionCard>
                    </Grid>
                )}

                {hirerConfig && <>
                {/* URLs */}
                <Grid item xs={12}>
                <SectionCard context="settings" title="URLs e Endpoints">
                    <Grid container spacing={2}>
                        {this.renderUrlField('Url API 2DO', hirerConfig.urlapicube)}
                        {this.renderUrlField('Url API 2SEE', hirerConfig.urlapivertex)}
                        {this.renderUrlField('Url acesso 2DO', hirerConfig.urlfrontcube)}
                        {this.renderUrlField('Url acesso 2SEE', hirerConfig.urlfrontvertex)}
                        {this.renderUrlField('Url API chamados', hirerConfig.urlapicubecalledservice)}
                        {this.renderUrlField('Url formulario padrao de chamados', hirerConfig.urlfrontcubecalledservice)}
                        {this.renderUrlField('Url API de relatorios', hirerConfig.urlapicubereports)}
                        {this.renderUrlField('Url API 2TALK', hirerConfig.urlapi2talkservice)}
                        {this.renderUrlField('Url interface webchat', hirerConfig.urlfront2talkwebchat)}
                    </Grid>
                </SectionCard></Grid>

                {/* General Info */}
                <Grid item xs={12}>
                <SectionCard context="info" title="Informações Gerais">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Email</Typography><Typography variant="body1">{hirerConfig.email || '-'}</Typography></Grid>
                        <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Workspace</Typography><Typography variant="body1">{hirerConfig.workspace || '-'}</Typography></Grid>
                        <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Ambiente</Typography><Typography variant="body1">{hirerConfig.environment || '-'}</Typography></Grid>
                        <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Versão do Banco</Typography><Typography variant="body1">{hirerConfig.databaseversion || '-'}</Typography></Grid>
                        <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Última Migration</Typography><Typography variant="body1">{hirerConfig.lastmigrationapplied || '-'}</Typography></Grid>
                        <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Data Última Migration</Typography><Typography variant="body1">{hirerConfig.lastmigrationdate ? new Date(hirerConfig.lastmigrationdate).toLocaleString('pt-BR') : '-'}</Typography></Grid>
                    </Grid>
                </SectionCard></Grid>

                {/* Cloud Provider */}
                {hirerConfig.cloudproviderconfigid && (
                    <Grid item xs={12}>
                    <SectionCard context="provisioning" title="Cloud Provider">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Provider</Typography><Typography variant="body1">{hirerConfig.cloudprovidername || '-'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Configuração</Typography><Typography variant="body1">{hirerConfig.cloudproviderconfigname || '-'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Região</Typography><Typography variant="body1">{hirerConfig.defaultregion || '-'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Profile</Typography><Typography variant="body1">{hirerConfig.profile || '-'}</Typography></Grid>
                            <Grid item xs={12} sm={4}><Typography variant="body2" color="textSecondary">Code</Typography><Typography variant="body1">{hirerConfig.code || '-'}</Typography></Grid>
                        </Grid>
                    </SectionCard></Grid>
                )}

                {/* URL Snapshots */}
                {this.state.urlSnapshots.length > 0 && (
                    <Grid item xs={12}>
                    <SectionCard context="history" title="Snapshots de URLs" subtitle="URLs salvas durante conversões de modo (dedicado/trial). Passe o mouse para ver os detalhes.">
                        {this.state.urlSnapshots.map((snap, idx) => (
                            <Tooltip key={idx} arrow placement="top"
                                title={
                                    <div style={{ padding: 8, fontSize: 12, lineHeight: 1.8 }}>
                                        <div><strong>url_api_cube:</strong> {snap.urlapicube || '-'}</div>
                                        <div><strong>url_api_vertex:</strong> {snap.urlapivertex || '-'}</div>
                                        <div><strong>url_api_cone:</strong> {snap.urlapicone || '-'}</div>
                                        <div><strong>url_api_called_service:</strong> {snap.urlapicubecalledservice || '-'}</div>
                                        <div><strong>url_api_reports:</strong> {snap.urlapicubereports || '-'}</div>
                                        <div><strong>url_api_2talk:</strong> {snap.urlapi2talkservice || '-'}</div>
                                        <div><strong>url_front_cube:</strong> {snap.urlfrontcube || '-'}</div>
                                        <div><strong>url_front_vertex:</strong> {snap.urlfrontvertex || '-'}</div>
                                        <div><strong>workspace:</strong> {snap.workspace || '-'}</div>
                                        <div><strong>environment:</strong> {snap.environment || '-'}</div>
                                    </div>
                                }
                            >
                                <div style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                    padding: '12px 16px', marginBottom: 8, borderRadius: 8,
                                    backgroundColor: '#f5f7fa', border: '1px solid #e0e0e0', cursor: 'default'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        <Chip label={snap.snapshottype} size="small" style={{
                                            backgroundColor: snap.snapshottype === 'dedicated_to_trial' ? '#bbdefb' : '#fff3e0',
                                            fontWeight: 500, fontSize: 11
                                        }} />
                                        {snap.workspace && <Chip label={snap.workspace} size="small" variant="outlined" style={{ fontSize: 11 }} />}
                                        <Typography variant="body2" style={{ color: '#616161' }}>
                                            {snap.createdat ? new Date(snap.createdat).toLocaleString('pt-BR') : '-'}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            API: {snap.urlapicube ? snap.urlapicube.substring(0, 30) + '...' : '-'}
                                        </Typography>
                                    </div>
                                    <Button
                                        variant="outlined" size="small" startIcon={<UndoIcon />}
                                        onClick={() => this.handleRestoreSnapshot(snap)}
                                        style={{ textTransform: 'none', fontWeight: 500, borderColor: '#ff9800', color: '#ff9800', fontSize: 12 }}
                                    >
                                        Restaurar
                                    </Button>
                                </div>
                            </Tooltip>
                        ))}
                    </SectionCard></Grid>
                )}
                </>}
            </Grid>
        );
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;
        const { detail, confirmDialog } = this.state;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='lg' style={{ paddingLeft: 24 }}>
                        <CssBaseline />

                        {detail && (
                            <>
                                <div style={{ marginBottom: 12 }}>
                                    <Button variant="text" color="primary" startIcon={<ArrowBackIcon />} onClick={() => this.props.history.push(`/${this.props.match.params.lang}/admin-trials`)}>
                                        {intl.formatMessage({ id: "back" })}
                                    </Button>
                                </div>

                                <Typography variant="h5" style={{ marginBottom: 16 }}>{detail.name} <span style={{ color: '#999', fontSize: 14 }}>({detail.workspace})</span></Typography>

                                <DeprovisioningBanner
                                    status={this.state.deprovisioningStatus}
                                    onAbortDeprovisioning={this.handleAbortDeprovisioning}
                                    onAbortDatabaseDrop={this.handleAbortDatabaseDrop}
                                    aborting={this.state.aborting}
                                />

                                <Tabs value={this.state.tabValue} onChange={(e, v) => {
                                    this.setState({ tabValue: v });
                                    if (v === 4 && detail?.hirerid) this.loadStatusHistory(detail.hirerid);
                                }} indicatorColor="primary" textColor="primary" style={{ marginBottom: 16 }}>
                                    <Tab label="Informações" />
                                    <Tab label={intl.formatMessage({ id: "admin.contract.products.title" })} />
                                    <Tab label="Provisionamento" />
                                    <Tab label="Outras Informações" />
                                    <Tab label="Histórico de Status" />
                                </Tabs>

                                {this.state.tabValue === 0 && this.renderInfoTab()}
                                {this.state.tabValue === 1 && this.renderProductsTab()}
                                {this.state.tabValue === 2 && this.renderProvisioningTab()}
                                {this.state.tabValue === 3 && this.renderHirerConfigTab()}
                                {this.state.tabValue === 4 && (
                                    <StatusHistoryTable
                                        items={this.state.statusHistory}
                                        loading={this.state.statusHistoryLoading}
                                        onRefresh={this.refreshStatusHistoryTab}
                                    />
                                )}
                            </>
                        )}

                        {/* Product Detail Dialog */}
                        {this.renderProductDetailDialog()}

                        {/* Confirm Dialog */}
                        <Dialog open={confirmDialog.open} onClose={() => this.setState({ confirmDialog: { open: false } })} maxWidth="xs" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                                <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>{confirmDialog.title}</Typography>
                                <IconButton size="small" onClick={() => this.setState({ confirmDialog: { open: false } })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <Divider />
                            <DialogContent style={{ padding: '16px 24px' }}><Typography>{confirmDialog.message}</Typography></DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                <Button onClick={() => this.setState({ confirmDialog: { open: false } })} style={{ textTransform: 'none', fontWeight: 500 }}>{intl.formatMessage({ id: "cancel" })}</Button>
                                <Button variant="contained" color="primary" onClick={confirmDialog.action} style={{ textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>{intl.formatMessage({ id: "confirm" })}</Button>
                            </div>
                        </Dialog>

                        {/* Assinar Plano Dialog (Stepper) */}
                        {(() => {
                            const { convertStep, convertSelectedProductIds, convertProductSelections, convertAvailablePlans, convertAvailablePeriodicities, convertProducts } = this.state;
                            const getAppName = (appId) => { const p = convertProducts.find(x => (x.id ?? x.applicationid ?? x.applicationId) === appId); return p ? (p.name ?? p.applicationname ?? p.applicationName) : `App ${appId}`; };
                            const allPlansSelected = convertSelectedProductIds.length > 0 && convertSelectedProductIds.every(id => convertProductSelections[id]?.planId);
                            const allPeriodicitiesSelected = convertSelectedProductIds.length > 0 && convertSelectedProductIds.every(id => convertProductSelections[id]?.ppId);
                            return (
                        <Dialog open={this.state.convertDialogOpen} onClose={() => this.setState({ convertDialogOpen: false })} maxWidth="md" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                                <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>{intl.formatMessage({ id: "admin.trial.convert" })}</Typography>
                                <IconButton size="small" onClick={() => this.setState({ convertDialogOpen: false })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <Divider />
                            <DialogContent style={{ padding: '24px', minHeight: 300 }}>
                                {/* Stepper visual */}
                                <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 24 }}>
                                    {['Produtos', 'Planos', 'Periodicidades', 'Resumo'].map((label, idx) => (
                                        <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                            <div style={{
                                                width: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                backgroundColor: convertStep >= idx ? '#277afe' : '#e0e0e0', color: '#fff', fontWeight: 600, fontSize: 13
                                            }}>{idx + 1}</div>
                                            <Typography variant="caption" style={{ fontWeight: convertStep === idx ? 600 : 400, color: convertStep === idx ? '#277afe' : '#999' }}>{label}</Typography>
                                            {idx < 3 && <div style={{ width: 32, height: 2, backgroundColor: convertStep > idx ? '#277afe' : '#e0e0e0' }} />}
                                        </div>
                                    ))}
                                </div>
                                {/* Passo 0: Selecionar Produtos */}
                                {convertStep === 0 && (
                                    <div>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>Selecione os produtos:</Typography>
                                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>Os produtos que o trial já possui estão pré-selecionados.</Typography>
                                        {this.state.convertProductsLoading ? <CircularProgress size={24} /> : (
                                            <Grid container spacing={2}>
                                                {convertProducts.map(prod => {
                                                    const prodId = prod.id ?? prod.applicationid ?? prod.applicationId;
                                                    const sel = convertSelectedProductIds.includes(prodId);
                                                    return (
                                                        <Grid item xs={12} sm={4} key={prodId}>
                                                            <div onClick={() => this.handleConvertToggleProduct(prodId)} style={{
                                                                cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #8BC34A' : '1px solid #e0e0e0',
                                                                backgroundColor: sel ? '#f1f8e9' : '#fff', textAlign: 'center', padding: 20, transition: 'all 0.2s', position: 'relative'
                                                            }}>
                                                                {sel && <CheckCircleIcon style={{ color: '#8BC34A', fontSize: 20, position: 'absolute', right: 12, top: 12 }} />}
                                                                <Typography variant="h6" style={{ fontWeight: 600, color: sel ? '#33691e' : '#424242' }}>{prod.name ?? prod.applicationname ?? prod.applicationName}</Typography>
                                                                <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>{prod.description ?? ''}</Typography>
                                                            </div>
                                                        </Grid>
                                                    );
                                                })}
                                                {convertProducts.length === 0 && <Typography color="textSecondary" style={{ padding: 16 }}>Nenhum produto disponível.</Typography>}
                                            </Grid>
                                        )}
                                    </div>
                                )}
                                {/* Passo 1: Selecionar Plano POR PRODUTO */}
                                {convertStep === 1 && (
                                    <div>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 16 }}>Selecione o plano para cada produto:</Typography>
                                        {this.state.convertPlansLoading ? <CircularProgress size={24} /> : (
                                            <div style={{ overflowY: 'auto', maxHeight: '60vh' }}>
                                                {convertSelectedProductIds.map(appId => {
                                                    const plans = convertAvailablePlans[appId] || [];
                                                    const selPlanId = convertProductSelections[appId]?.planId;
                                                    return (
                                                        <div key={appId} style={{ marginBottom: 24 }}>
                                                            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8, color: '#277afe' }}>{getAppName(appId)}</Typography>
                                                            <Grid container spacing={2}>
                                                                {plans.map(plan => {
                                                                    const sel = selPlanId === plan.id;
                                                                    return (
                                                                        <Grid item xs={12} sm={4} key={plan.id}>
                                                                            <div onClick={() => this.handleConvertSelectPlanForApp(appId, plan)} style={{
                                                                                cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #277afe' : '1px solid #e0e0e0',
                                                                                backgroundColor: sel ? '#e3f2fd' : '#fff', textAlign: 'center', padding: 16, transition: 'all 0.2s', position: 'relative'
                                                                            }}>
                                                                                {sel && <CheckCircleIcon style={{ color: '#277afe', fontSize: 18, position: 'absolute', right: 8, top: 8 }} />}
                                                                                <Typography variant="body1" style={{ fontWeight: 600, color: sel ? '#0d47a1' : '#424242' }}>{plan.name}</Typography>
                                                                                <Chip label={plan.isShared ? 'Compartilhado' : 'Dedicado'} size="small" style={{ marginTop: 4, backgroundColor: plan.isShared ? '#e0e0e0' : '#bbdefb', fontSize: 11 }} />
                                                                            </div>
                                                                        </Grid>
                                                                    );
                                                                })}
                                                                {plans.length === 0 && <Grid item xs={12}><Typography variant="body2" color="textSecondary">Nenhum plano disponível para este produto.</Typography></Grid>}
                                                            </Grid>
                                                            {appId !== convertSelectedProductIds[convertSelectedProductIds.length - 1] && <Divider style={{ marginTop: 16 }} />}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {/* Passo 2: Selecionar Periodicidade POR PRODUTO */}
                                {convertStep === 2 && (
                                    <div>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 16 }}>Selecione a periodicidade para cada produto:</Typography>
                                        {this.state.convertPeriodicitiesLoading ? <CircularProgress size={24} /> : (
                                            <div style={{ overflowY: 'auto', maxHeight: '60vh' }}>
                                                {convertSelectedProductIds.map(appId => {
                                                    const periodicities = convertAvailablePeriodicities[appId] || [];
                                                    const selPpId = convertProductSelections[appId]?.ppId;
                                                    return (
                                                        <div key={appId} style={{ marginBottom: 24 }}>
                                                            <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 4, color: '#277afe' }}>{getAppName(appId)}</Typography>
                                                            <Typography variant="caption" color="textSecondary" style={{ marginBottom: 8, display: 'block' }}>Plano: {convertProductSelections[appId]?.planName}</Typography>
                                                            <Grid container spacing={2}>
                                                                {periodicities.map(pp => {
                                                                    const sel = selPpId === pp.id;
                                                                    return (
                                                                        <Grid item xs={12} sm={4} key={pp.id}>
                                                                            <div onClick={() => this.handleConvertSelectPeriodicityForApp(appId, pp)} style={{
                                                                                cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #ff9800' : '1px solid #e0e0e0',
                                                                                backgroundColor: sel ? '#fff3e0' : '#fff', textAlign: 'center', padding: 16, transition: 'all 0.2s', position: 'relative'
                                                                            }}>
                                                                                {sel && <CheckCircleIcon style={{ color: '#ff9800', fontSize: 18, position: 'absolute', right: 8, top: 8 }} />}
                                                                                <Typography variant="body1" style={{ fontWeight: 500 }}>{pp.periodicityname ?? pp.periodicityName}</Typography>
                                                                                <Typography variant="h6" style={{ color: '#ff9800', fontWeight: 700, marginTop: 4 }}>R$ {Number(pp.planvaluepermonth ?? pp.planValuePerMonth ?? pp.value ?? 0).toFixed(2)}</Typography>
                                                                            </div>
                                                                        </Grid>
                                                                    );
                                                                })}
                                                                {periodicities.length === 0 && <Grid item xs={12}><Typography variant="body2" color="textSecondary">Nenhuma periodicidade disponível.</Typography></Grid>}
                                                            </Grid>
                                                            {appId !== convertSelectedProductIds[convertSelectedProductIds.length - 1] && <Divider style={{ marginTop: 16 }} />}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {/* Passo 3: Resumo */}
                                {convertStep === 3 && (
                                    <div>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 16 }}>Resumo da assinatura:</Typography>
                                        <TableContainer component={Paper} variant="outlined" style={{ borderRadius: 8 }}>
                                            <Table size="small">
                                                <TableHead><TableRow style={{ backgroundColor: '#fafafa' }}>
                                                    <TableCell style={{ fontWeight: 600 }}>Produto</TableCell>
                                                    <TableCell style={{ fontWeight: 600 }}>Plano</TableCell>
                                                    <TableCell style={{ fontWeight: 600 }}>Tipo</TableCell>
                                                    <TableCell style={{ fontWeight: 600 }}>Periodicidade</TableCell>
                                                    <TableCell align="right" style={{ fontWeight: 600 }}>Valor/mês</TableCell>
                                                </TableRow></TableHead>
                                                <TableBody>
                                                    {convertSelectedProductIds.map(appId => {
                                                        const sel = convertProductSelections[appId] || {};
                                                        return (
                                                            <TableRow key={appId}>
                                                                <TableCell><strong>{getAppName(appId)}</strong></TableCell>
                                                                <TableCell>{sel.planName || '-'}</TableCell>
                                                                <TableCell><Chip label={sel.isShared ? 'Compartilhado' : 'Dedicado'} size="small" style={{ backgroundColor: sel.isShared ? '#e0e0e0' : '#bbdefb', fontSize: 11 }} /></TableCell>
                                                                <TableCell>{sel.ppName || '-'}</TableCell>
                                                                <TableCell align="right" style={{ color: '#ff9800', fontWeight: 600 }}>R$ {Number(sel.value || 0).toFixed(2)}</TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                    <TableRow>
                                                        <TableCell colSpan={4} style={{ fontWeight: 700, textAlign: 'right' }}>Total/mês:</TableCell>
                                                        <TableCell align="right" style={{ fontWeight: 700, color: '#277afe', fontSize: 16 }}>R$ {convertSelectedProductIds.reduce((sum, id) => sum + Number(convertProductSelections[id]?.value || 0), 0).toFixed(2)}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Divider style={{ margin: '16px 0' }} />
                                        <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>
                                            Ao confirmar, o contrato será convertido do modo Trial para os planos selecionados.
                                            {Object.values(convertProductSelections).some(s => s.isShared === false) && ' A infraestrutura dedicada será provisionada automaticamente.'}
                                        </Typography>
                                    </div>
                                )}
                            </DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                <Button onClick={() => this.setState({ convertDialogOpen: false })} style={{ textTransform: 'none', fontWeight: 500 }}>{intl.formatMessage({ id: "cancel" })}</Button>
                                {convertStep > 0 && <Button onClick={() => this.setState(prev => ({ convertStep: prev.convertStep - 1 }))} style={{ textTransform: 'none', fontWeight: 500 }}>Voltar</Button>}
                                {convertStep < 3 && (
                                    <Button variant="contained" color="primary"
                                        disabled={
                                            (convertStep === 0 && convertSelectedProductIds.length === 0) ||
                                            (convertStep === 1 && !allPlansSelected) ||
                                            (convertStep === 2 && !allPeriodicitiesSelected)
                                        }
                                        onClick={this.handleConvertNext}
                                        style={{ textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>
                                        Próximo
                                    </Button>
                                )}
                                {convertStep === 3 && (
                                    <Button variant="contained" onClick={this.handleConvertConfirm}
                                        style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>
                                        Assinar Plano
                                    </Button>
                                )}
                            </div>
                        </Dialog>
                            );
                        })()}
                        <ConfirmActionDialog open={this.state.cancelDialogOpen} onClose={() => this.setState({ cancelDialogOpen: false })} onConfirm={this.handleCancelConfirm} title={intl.formatMessage({ id: "admin.trial.cancel.dialog.title" })} message={intl.formatMessage({ id: "admin.trial.cancel.dialog.message" })} description={detail ? intl.formatMessage({ id: "admin.trial.cancel.dialog.description" }, { name: detail.name, workspace: detail.workspace }) : ''} confirmLabel={intl.formatMessage({ id: "admin.trial.cancel.dialog.confirm" })} cancelLabel={intl.formatMessage({ id: "back" })} confirmColor="#f44336" icon={CancelIcon} iconColor="#f44336" />
                        <ConfirmActionDialog open={this.state.blockDialogOpen} onClose={() => this.setState({ blockDialogOpen: false })} onConfirm={this.handleBlockConfirm} title={intl.formatMessage({ id: "admin.block.dialog.title" })} message={intl.formatMessage({ id: "admin.block.dialog.message" })} description={detail ? intl.formatMessage({ id: "admin.block.dialog.description" }, { name: detail.name }) : ''} confirmLabel={intl.formatMessage({ id: "admin.block.dialog.confirm" })} cancelLabel={intl.formatMessage({ id: "back" })} confirmColor="#ff9800" icon={BlockIcon} iconColor="#ff9800" />
                        <ConfirmActionDialog open={this.state.reactivateDialogOpen} onClose={() => this.setState({ reactivateDialogOpen: false })} onConfirm={this.handleReactivateConfirm} title={intl.formatMessage({ id: "admin.trial.reactivate" })} message={detail ? `Reativar o trial "${detail.name}" (${detail.workspace}) — voltará para o status "Em Trial".` : ''} description="O trial volta a ficar ativo. Sem efeitos colaterais externos (apenas BD)." confirmLabel={intl.formatMessage({ id: "admin.trial.reactivate" })} cancelLabel={intl.formatMessage({ id: "back" })} confirmColor="#4caf50" icon={RefreshIcon} iconColor="#4caf50" />
                        <ConfirmActionDialog open={this.state.abortConfirmOpen} onClose={() => this.setState({ abortConfirmOpen: false })} onConfirm={this.confirmAbortDeprovisioning} title="Abortar desprovisionamento" message="Tem certeza que deseja abortar o desprovisionamento agendado?" description="O ambiente voltará ao estado anterior (status, hirer, contrato) e o agendamento será cancelado. Apenas o registro do agendamento é desfeito; nenhum dado é perdido." confirmLabel="Abortar agora" cancelLabel="Voltar" confirmColor="#f57c00" iconColor="#f57c00" />
                        <ConfirmActionDialog open={this.state.abortDropConfirmOpen} onClose={() => this.setState({ abortDropConfirmOpen: false })} onConfirm={this.confirmAbortDatabaseDrop} title="Abortar deleção do banco de dados" message="Tem certeza que deseja abortar a deleção do banco de dados?" description="O banco de dados continuará preservado indefinidamente. O agendamento de deleção é cancelado." confirmLabel="Abortar deleção" cancelLabel="Voltar" confirmColor="#546e7a" iconColor="#546e7a" />
                        <AddProductWizard open={this.state.addProductDialogOpen} onClose={() => this.setState({ addProductDialogOpen: false })} onConfirm={this.handleAddProductConfirm} />
                        <ConfirmActionDialog open={this.state.removeProductDialogOpen} onClose={() => this.setState({ removeProductDialogOpen: false, removeProductId: null })} onConfirm={this.handleRemoveProductConfirm} title={intl.formatMessage({ id: "admin.contract.products.remove" })} message={intl.formatMessage({ id: "admin.contract.products.remove.confirm" })} confirmLabel={intl.formatMessage({ id: "admin.contract.products.remove" })} cancelLabel={intl.formatMessage({ id: "back" })} confirmColor="#f44336" icon={DeleteIcon} iconColor="#f44336" />

                        <DangerConfirmDialog
                            open={this.state.dangerDialogOpen}
                            onClose={() => this.setState({ dangerDialogOpen: false, dangerCodeSentState: null })}
                            onConfirm={this.handleScheduleDeprovisioning}
                            workspace={detail?.workspace || ''}
                            title="Excluir trial"
                            message={detail ? `Agendar desprovisionamento de "${detail.name}" (${detail.workspace}).` : ''}
                            description="Após o período de carência, o ambiente será derrubado (infra, gateway) e os registros SaaS deletados. O banco de dados do contratante é preservado por 30 dias — depois, deletado permanentemente. Você pode abortar o desprovisionamento enquanto ainda estiver agendado."
                            warningText="Essa ação não pode ser desfeita após o período de carência."
                            confirmLabel="Agendar desprovisionamento"
                            loading={this.state.dangerLoading}
                            requireReason
                            requireTwoFactor
                            onSendCode={this.handleSendScheduleDeprovCode}
                            sendingCode={this.state.dangerSendingCode}
                            codeSentState={this.state.dangerCodeSentState}
                            defaultEmail={this.props.userSession?.user?.email || ''}
                        />

                        <ForceDropConfirmDialog
                            open={this.state.forceDropDialogOpen}
                            onClose={this.closeForceDropDialog}
                            workspace={detail?.workspace || ''}
                            defaultEmail={this.props.userSession?.user?.email || ''}
                            onSendCode={this.handleSendForceDropCode}
                            onConfirm={this.handleForceDatabaseDrop}
                            sending={this.state.forceDropSending}
                            submitting={this.state.forceDropSubmitting}
                            codeSentState={this.state.forceDropCodeSentState}
                            submitError={this.state.forceDropError}
                        />

                        <Dialog open={this.state.companySizeDialogOpen} onClose={this.closeCompanySizeDialog} maxWidth="xs" fullWidth>
                            <DialogTitle>{intl.formatMessage({ id: "admin.hirer.company_size.edit" })}</DialogTitle>
                            <DialogContent>
                                <TextField
                                    select
                                    SelectProps={{ native: true }}
                                    InputLabelProps={{ shrink: true }}
                                    label={intl.formatMessage({ id: "admin.hirer.company_size" })}
                                    value={this.state.companySizeDialogValue}
                                    onChange={(e) => this.setState({ companySizeDialogValue: e.target.value })}
                                    fullWidth
                                >
                                    <option value="">{intl.formatMessage({ id: "admin.hirer.company_size.placeholder" })}</option>
                                    {this.state.companySizes.map(cs => (
                                        <option key={cs.id} value={cs.id}>{cs.name}</option>
                                    ))}
                                </TextField>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.closeCompanySizeDialog} disabled={this.state.companySizeSaving}>{intl.formatMessage({ id: "cancel" })}</Button>
                                <Button onClick={this.handleSaveCompanySize} variant="contained" color="primary" disabled={this.state.companySizeSaving}>{intl.formatMessage({ id: "save" })}</Button>
                            </DialogActions>
                        </Dialog>

                        {(this.state.loading || this.state.actionLoading) && (<Overlay><CircularProgress color="secondary" /></Overlay>)}
                        <CustomizedSnackbars variant={this.state.notificationVariant} message={this.state.notificationMessage} isOpen={this.state.openNotification} toClose={this.closeNotification} />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminTrialDetail.propTypes = { classes: PropTypes.object.isRequired };

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
    currentTrial: state.adminBilling.currentTrial,
});

const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminTrialDetail)));
